<template>
	<div class="eia-page-footer">
		<eia-find-out-more
			v-if="showFindOutMore">
		</eia-find-out-more>

		<eia-contact-bar></eia-contact-bar>
		<eia-footer-links></eia-footer-links>
	</div>
</template>

<script>
import result from 'lodash.result';

export default {
	name: 'eia-page-footer',
	computed: {
		showFindOutMore() {
			return result( this, '$route.meta.showFindOutMore', false );
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-page-footer {
	position: relative;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
}
</style>
